module.exports = __webpack_public_path__ + "static/media/ambulance.4c7ea621.svg";